import React from "react";
import {
  Box,
  Button,
  AppBar,
  Toolbar,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Iconify from "../iconify/Iconify";
import OutletTypesMenu from "./OutletTypesMenu";
import { useState } from "react";
import SiteLogo from "../site-logo/SiteLogo";

function ElevationOnScroll({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 10,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 1 : 0,
    style: {
      ...children.props.style,
      boxShadow: trigger ? "0 2px 10px rgba(0,0,0,0.08)" : "none",
      transition: "box-shadow 0.3s ease",
    },
  });
}

export default function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHoveringMenu, setIsHoveringMenu] = useState(false);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    // Only close if NOT hovering menu
    if (!isHoveringMenu) {
      setAnchorEl(null);
    }
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <ElevationOnScroll>
        <AppBar
          position="fixed"
          color="transparent"
          elevation={0}
          style={{
            minHeight: "65px",
            padding: "0px 80px",
            background: "#fff",
          }}
        >
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Box display="flex" gap={15}>          
              <SiteLogo color={"#000"} />
              <Box
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="text"
                  onClick={handleOpen}
                  sx={{
                    color: "#000",
                    cursor: "pointer",
                    textTransform: "none",
                  }}
                >
                  Outlet Types
                  <Iconify
                    icon="material-symbols:arrow-drop-down"
                    width={20}
                    style={{ marginLeft: 8 }}
                  />
                </Button>

                <OutletTypesMenu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  setIsHoveringMenu={setIsHoveringMenu}
                />

                <Button
                  component={RouterLink}
                  to="/pos/pricing"
                  variant="text"
                  style={{
                    color: "#000",
                  }}
                >
                  Pricing
                </Button>
              </Box>
            </Box>

            <Box display="flex" gap={2} alignItems="center">
              <Button
                component={RouterLink}
                to="/login"
                variant="outlined"
                style={{
                  color: "#000",
                  borderColor: "#000",
                }}
              >
                Login
              </Button>
              <Button
                component={RouterLink}
                to="/pos/book-demo"
                variant="contained"
                style={{
                  color: "#fff",
                  backgroundColor: "#f6521a",
                }}
              >
                Book a Demo
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
      </ElevationOnScroll>
    </>
  );
}
